"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalDeep = equalDeep;
exports.filterKeys = filterKeys;
exports.filterValues = filterValues;
exports.mapEntries = mapEntries;
exports.mapValues = mapValues;
exports.mapEntriesAsync = mapEntriesAsync;
exports.mapValuesAsync = mapValuesAsync;
exports.minusFieldsDeep = minusFieldsDeep;
exports.objectSame = objectSame;
exports.removeEmpty = removeEmpty;
exports.mapEntriesDeep = mapEntriesDeep;
exports.removeFieldsDeep = removeFieldsDeep;
exports.removeUndefined = removeUndefined;
const validation_1 = require("./validation");
const any_1 = require("./any");
// functions sorted alphabetically
function equalDeep(a, b) {
    if (typeof a === 'string' || typeof a === 'number' || typeof a === 'boolean' || typeof a === 'symbol' || a === null || a === undefined) {
        return a === b;
    }
    else if (Array.isArray(a)) {
        return Array.isArray(b) && a.length === b.length && a.every((v, i) => equalDeep(v, b[i]));
    }
    else if (typeof a === 'object') {
        if (typeof b === 'object' && !Array.isArray(b) && b !== null) {
            return Object.keys(a).length === Object.keys(b).length && Object.entries(a).every(([k, v]) => equalDeep(v, b[k]));
        }
    }
    return false;
}
function filterKeys(obj, p) {
    return Object.fromEntries(Object.entries(obj).filter(([k,]) => p(k)));
}
function filterValues(obj, p) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => p(v)));
}
function mapEntries(obj, f) {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, f(k, v)]));
}
function mapValues(obj, f) {
    return mapEntries(obj, (_, v) => f(v));
}
function mapEntriesAsync(obj, f) {
    return Promise.all(Object.entries(obj).map(([k, v]) => f(k, v).then(u => [k, u]))).then(Object.fromEntries);
}
function mapValuesAsync(obj, f) {
    return mapEntriesAsync(obj, (_, v) => f(v));
}
// remove fields from `source` if they exist and have the same value in `ref`
function minusFieldsDeep(source, ref) {
    if (typeof source === 'string' || typeof source === 'number' || typeof source === 'boolean' || typeof source === 'symbol' || source === null || source === undefined) {
        return source !== ref ? source : undefined;
    }
    else if (Array.isArray(source)) {
        if (Array.isArray(ref)) {
            const arr = source.map((v, i) => minusFieldsDeep(v, ref[i]));
            return arr.some(v => v !== undefined) ? arr : undefined;
        }
        else {
            return source;
        }
    }
    else if (typeof source === 'object') {
        if (typeof ref === 'object' && !Array.isArray(ref) && ref !== null) {
            const obj = Object.fromEntries(Object.entries(source).map(([key, value]) => [key, minusFieldsDeep(value, ref[key])]).filter(([, v]) => v !== undefined));
            return Object.keys(obj).length > 0 ? obj : undefined;
        }
        else {
            return source;
        }
    }
}
function objectSame(a, b) {
    if (a instanceof Date && b instanceof Date)
        return a.getTime() === b.getTime();
    if ((a instanceof Number || a instanceof Boolean) && (b instanceof Number || b instanceof Boolean))
        return a.valueOf() === b.valueOf();
    const aEntries = Object.entries(a);
    const bEntries = Object.entries(b);
    return aEntries.length === bEntries.length && aEntries.every(([key, value]) => (0, any_1.anySame)(value, b[key]));
}
function removeEmpty(obj) {
    return filterValues(obj, v => !(0, validation_1.isEmpty)(v));
}
function mapEntriesDeep(obj, f, path = []) {
    if (Array.isArray(obj)) {
        return obj.map((item, i) => mapEntriesDeep(item, f, [...path, i]));
    }
    if (typeof obj === 'object' && obj !== null) {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => {
            const entryPath = [...path, key];
            return [key, f(entryPath, mapEntriesDeep(value, f, entryPath))];
        }));
    }
    return obj;
}
function removeFieldsDeep(obj, keysToRemove) {
    if (Array.isArray(obj)) {
        return obj.map(item => removeFieldsDeep(item, keysToRemove));
    }
    if (typeof obj === 'object' && obj !== null) {
        const res = {};
        Object.keys(obj).forEach(key => {
            if (keysToRemove.indexOf(key) < 0) {
                res[key] = removeFieldsDeep(obj[key], keysToRemove);
            }
        });
        return res;
    }
    return obj;
}
function removeUndefined(obj) {
    return filterValues(obj, v => v !== undefined);
}
//# sourceMappingURL=object.js.map